import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

/**
 * Combines class names using `clsx` and merges Tailwind CSS classes using `tailwind-merge`.
 *
 * This utility is useful for conditionally joining class names and resolving Tailwind CSS class conflicts.
 *
 * @param inputs - Any number of class values (strings, arrays, objects, etc.)
 * @returns A single string of merged class names.
 *
 * @example
 * ```tsx
 * <div className={cn("p-2", "bg-red-500", { "text-white": isActive })} />
 * ```
 *
 * @example
 * ```tsx
 * // Merges conflicting Tailwind classes - the latter overwrites the former:
 * cn("p-2", "p-4") // => "p-4"
 * ```
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
